import { Controller } from "@hotwired/stimulus";

// Loads the files drawer turbo-frame the first time the drawer is opened.
// Deliberate src-on-toggle instead of loading="lazy": daisyUI's .drawer-side is
// a fixed, full-viewport element hidden via visibility/opacity, which
// IntersectionObserver treats as intersecting, so a lazy frame would load eagerly.
export default class extends Controller {
  static targets = ["frame"];
  static values = { url: String };

  load(event) {
    if (!event.target.checked) return;
    if (this.frameTarget.src) return;

    this.frameTarget.src = this.urlValue;
  }
}
